/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetTuyaPairingSessionPathParameters } from 'api/actions/get-tuya-pairing-session/get-tuya-pairing-session-path-parameters';
import { GetTuyaPairingSessionResponse } from 'api/actions/get-tuya-pairing-session/get-tuya-pairing-session-response';

type GetTuyaPairingSessionQueryParameters = Record<string, any>;

/**
 * The path of the GetTuyaPairingSession action.
 */
export const getTuyaPairingSessionActionPath = new SweetPath<keyof GetTuyaPairingSessionPathParameters>(
  '/tuya-device-pairing-sessions/{sessionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetTuyaPairingSession actions.
 */
export default function createGetTuyaPairingSessionAction(axios: AxiosInstance) {
  return function getTuyaPairingSessionAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetTuyaPairingSessionPathParameters;
    query?: GetTuyaPairingSessionQueryParameters;
  }) {
    const path = getTuyaPairingSessionActionPath.insert(parameters);

    return axios.get<GetTuyaPairingSessionResponse, GetTuyaPairingSessionResponse>(path, { params: query, headers });
  };
}
